import { IMsalContext } from '@azure/msal-react';
import { appSettings, loginRequest } from '../../AppSettings'
import { Wiki, WikiPage, ErrorResponse, WikiPageContent, StatusData } from "./Model";

export async function getWikis(context: IMsalContext) : Promise<Array<Wiki>> {
    var result = await get<Array<Wiki>>(`/api/wiki/menu`, context);

    if (result === null)
        throw new Error("Nie znaleziono menu.");

    return result;
}

export async function getWikiPageContent(context: IMsalContext, repository: string, page: WikiPage): Promise<string> {
    var encodedUri = encodeURIComponent(page.fileUrl);
    var result = await get<WikiPageContent>(`/api/wiki/${repository}/page/${encodedUri}`, context);

    if (result === null)
        throw new Error("Nie znaleziono strony w wiki.");

    return result?.page;
}

export async function forceUploadWikiFiles(context: IMsalContext) : Promise<void> {
    await put(`/api/wiki/update`, context);
}

export async function getStatus(context: IMsalContext) {
    var result = await get<StatusData>(`/api/wiki/getstatus`, context);    
    return result;
}

async function get<TResponse>(url: string, context: IMsalContext, abortController?: AbortController) : Promise<TResponse | null> {
    const headers = await getHeaders(context);
    const options = {
        method: 'GET',
        headers: headers,
        signal: abortController?.signal
    }
    const response = await fetch(`${appSettings.API_URL}${url}`, options)

    if (!response.ok)
        handleError(await response.json() as ErrorResponse);

    if (response.status === 204)
        return null;

    return await response.json() as TResponse;
}

async function put(url: string, context: IMsalContext, abortController?: AbortController) : Promise<void> {
    const headers = await getHeaders(context);
    const options = {
        method: 'PUT',
        headers: headers,
        signal: abortController?.signal
    }
    const response = await fetch(`${appSettings.API_URL}${url}`, options)

    if (!response.ok)
        handleError(await response.json() as ErrorResponse);
}

function handleError(error: ErrorResponse) {
    console.log(error);

    throw new Error(`${error.extensions?.errorCode ?? 'Error'}: ${error.title}`);
}

async function getHeaders(context: IMsalContext) : Promise<Headers> {
    const token = await getBearerToken(context);
    const headers = new Headers();
    
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', token);

    return headers;
}

async function getBearerToken(context: IMsalContext): Promise<string> {
    const accessToken = await getAccessToken(context);

    return `Bearer ${accessToken}`;
}

async function getAccessToken(context: IMsalContext): Promise<string> {
    const result = await context.instance 
        .acquireTokenSilent({...loginRequest, account: context.accounts[0]});

    return result.accessToken;
}